// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"6ac5847b","329":"d1ea7fe3","718":"eb8554d7","845":"3dca124e"}[chunkId] + ".chunk.js";
};